import { computed, inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, EMPTY, exhaustMap, pipe, tap } from 'rxjs';

import { errorCode } from '../data/api/api-error';
import { SiteApi } from '../data/api/site.api';

export type SiteStatus = 'checking' | 'ready' | 'notConfigured' | 'error';

type SiteState = {
  status: SiteStatus;
};

/** Организацию бэкенд определяет по домену: 404 `org_not_found` → заглушка, сеть/5xx → ошибка (Р-6). */
export const SiteStore = signalStore(
  { providedIn: 'root' },
  withState<SiteState>({ status: 'checking' }),

  withComputed(({ status }) => ({
    // Блокирует только непривязанный домен: при сетевой ошибке у страниц есть свои экраны с «Повторить».
    isBlocked: computed((): boolean => status() === 'notConfigured'),
  })),

  withMethods((store, api = inject(SiteApi)) => ({
    check: rxMethod<void>(
      pipe(
        // exhaustMap: повтор во время полёта игнорируется, поэтому статус сбрасываем только у принятого вызова.
        exhaustMap(() => {
          patchState(store, { status: 'checking' });
          return api.checkDomain().pipe(
            tap(() => patchState(store, { status: 'ready' })),
            // catchError во ВНУТРЕННЕМ pipe, чтобы ошибка не убила поток rxMethod.
            catchError((error: unknown) => {
              const failed = errorCode(error) === 'org_not_found' ? 'notConfigured' : 'error';
              patchState(store, { status: failed });
              return EMPTY;
            }),
          );
        }),
      ),
    ),
  })),

  withHooks({
    onInit(store) {
      store.check();
    },
  }),
);
